module.exports = __webpack_public_path__ + "static/media/tiktok.4d187b98.png";